// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import connectActions from 'utils/connectActions'
import { withStyles } from '@material-ui/core/styles'

// Actions
import { requestVerify } from 'actions/actions'

// Atoms
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ErrorCard from 'atoms/ErrorCard'
import ContentLoader from 'atoms/ContentLoader'
import { AppProgressActivator } from 'atoms/AppProgress'
import CenteredCard from 'atoms/CenteredCard'
import Chip from 'atoms/Chip'
import Link from 'atoms/Link'
import Spacer from 'atoms/Spacer'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'

// Icons
import CheckCircleIcon from '@material-ui/icons/CheckCircle'

// Styles
const styles = () => ({
  button: {
    cursor: 'pointer'
  },
})

const mapActionsToProps = {
  requestVerifyAction: requestVerify
}

export default
@withStyles(styles)
@connectActions(mapActionsToProps)
class RequestVefiryAction extends Component {
  static propTypes = {
    requestVerifyAction: PropTypes.object.isRequired,
    token: PropTypes.string,
    classes: PropTypes.object.isRequired,
  }

  async componentDidMount() {
    const { requestVerifyAction, token } = this.props
    await requestVerifyAction.run({
      params: [token],
      silent: true,
    })
  }

  render() {
    const { requestVerifyAction, classes } = this.props

    if (requestVerifyAction.isDefault || requestVerifyAction.isPending) {
      return (
        <Fragment>
          <AppProgressActivator />
          <ContentLoader centered />
        </Fragment>
      )
    }

    if (requestVerifyAction.isFailed) {
      return (
        <ErrorCard
          primary="Request verification error"
          secondary={requestVerifyAction.error.message}
        />
      )
    }

    return (
      <Fragment>
        <CenteredCard>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon />
              </ListItemIcon>
              <ListItemText
                primary="Your request has been verified"
                secondary={(
                  <Fragment>
                    <b>{ requestVerifyAction.result.business.name }</b>
                    {' '}
                    will be in touch soon
                  </Fragment>
                )}
              />
            </ListItem>
          </List>
        </CenteredCard>
        <Spacer large />
        <center>
          <Chip
            active
            to="/signup"
            component={Link}
            className={classes.button}
            rightIcon={ChevronRightIcon}
          >
            Get your own indemandly link - it’s free
          </Chip>
        </center>
      </Fragment>
    )
  }
}
